import i18n from "../../../react-i18next-ex/i18next";
export const changeLanguage = (fl) => {
  if (fl) {
    i18n.changeLanguage(fl);
    if (fl === "fa") {
      localStorage.setItem("language", fl);
      document.documentElement.dir = "rtl";
    } else {
        i18n.changeLanguage(fl);

      localStorage.setItem("language", fl);
      document.documentElement.dir = "ltr";
    }
  }
};
